var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcInapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "s3v0cq5mfa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 12728",
    transform: "translate(0 .345)",
    style: {
      fill: "#4493f9"
    },
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 39282",
    transform: "translate(0 -.345)",
    style: {
      clipPath: "url(#s3v0cq5mfa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 72195",
    d: "M13.949 8.439h9.308V7.46A1.96 1.96 0 0 0 21.3 5.5h-7.84a1.96 1.96 0 0 0-1.96 1.96v14.7a1.96 1.96 0 0 0 1.96 1.96h7.84a1.96 1.96 0 0 0 1.96-1.96V8.439H21.3v10.778a.49.49 0 0 1-.49.49h-6.861a.49.49 0 0 1-.49-.49V8.929a.49.49 0 0 1 .49-.49m3.919 14.452h-.98a.98.98 0 1 1 0-1.96h.98a.98.98 0 0 1 0 1.96",
    transform: "translate(-7.599 -4.635)",
    style: {
      fill: "current"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInapp);
export default __webpack_public_path__ + "static/media/ic_inapp.088ccfe021fd2766e0eaef4b57876baa.svg";
export { ForwardRef as ReactComponent };